import API from "@utils/request";
import { navigate } from "@utils";

import { FILE_ROOT, pathLoac } from "@config";

let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {

} else {
    prout = 'protal_' + Language;
}

// 场景列表points/scenesList
export async function getScenesList(params) {
    try {
        return await API.post("api/" + prout + "/api/points/scenesList", params);
    } catch (error) {
        return error;
    }
}

// 项目列表
export async function getProgramsList(params) {
    try {
        return await API.post("api/" + prout + "/api/points/programsList", params);
    } catch (error) {
        return error;
    }
}


// 活动区域列表  points/findActivityInfo
export async function getActivityInfo(params) {
    try {
        return await API.post("api/" + prout + "/api/points/findActivityInfo", params);
    } catch (error) {
        return error;
    }
}


// 获取积分列表
export async function getPointsList(params) {
    try {
        return await API.post("api/" + prout + "/api/points/list", params);
    } catch (error) {
        return error;
    }
}


// 提交积分申请
export async function submitPoints(params) {
    try {
        return await API.post("api/" + prout + "/api/points/submit", params);
    } catch (error) {
        return error;
    }
}

// 详情 points/info
export async function getPointsInfo(params) {
    try {
        return await API.post("api/" + prout + "/api/points/info", params);
    } catch (error) {
        return error;
    }
}

// 编辑积分申请 points/edit
export async function editPoints(params) {
    try {
        return await API.post("api/" + prout + "/api/points/edit", params);
    } catch (error) {
        return error;
    }
}

// 再次提交积分申请 points/resubmit
export async function resubmitPoints(params) {
    try {
        return await API.post("api/" + prout + "/api/points/resubmit", params);
    } catch (error) {
        return error;
    }
}

// 撤回积分申请 points/withdraw
export async function withdrawPoints(params) {
    try {
        return await API.post("api/" + prout + "/api/points/withdraw", params);
    } catch (error) {
        return error;
    }
}

// 积分申请说明 points/getInstructions
export async function getPointsInstructions(params) {
    try {
        return await API.post("api/" + prout + "/api/points/getInstructions", params);
    } catch (error) {
        return error;
    }
}

// 地区树键值 points/areaKeyVal
export async function getAreaKeyVal(params) {
    try {
        return await API.post("api/" + prout + "/api/points/areaKeyVal", params);
    } catch (error) {
        return error;
    }
}
